import { useUserLanguage, useCreateCommunicationContext } from '@/customHooks';
import textsData from '@/textData/CreateCommunicationsTexts.json';

export const CommunicationConfirmationDialog = () => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en;
  const { state, setButtonEnabled } = useCreateCommunicationContext();

  // En la pantalla de resumen siempre permitimos avanzar
  setButtonEnabled();

  const mapAudience = () => {
    const hasPropertyScope = state.selectedPropertyIds.length > 0;
    const propertyHint = hasPropertyScope
      ? ` · ${state.selectedPropertyIds.length} prop.`
      : '';

    if (hasPropertyScope && state.allStakeholdersOnSelectedProperties) {
      return `${texts.confirmation.allStakeholdersOnProperties}${propertyHint}`;
    }

    if (state.targetUserTypes.length === 0) return texts.confirmation.noAudience;

    const labels: string[] = [];
    if (state.targetUserTypes.includes('ALL')) {
      labels.push(texts.audience.tenant, texts.audience.owner, texts.audience.supplier);
    } else {
      if (state.targetUserTypes.includes('TENANT')) labels.push(texts.audience.tenant);
      if (state.targetUserTypes.includes('OWNER')) labels.push(texts.audience.owner);
      if (state.targetUserTypes.includes('SUPPLIER')) labels.push(texts.audience.supplier);
    }
    const typeLabels = labels.join(', ');
    const userTypesTexts = texts.audience.userTypes as { allUsers?: string; selectUserPlaceholder?: string } | undefined;
    const base = state.allUsersSelected
      ? `${typeLabels} (${userTypesTexts?.allUsers ?? 'all'})`
      : `${typeLabels} - ${state.selectedUserIds.length} selected`;
    return `${base}${propertyHint}`;
  };

  return (
    <div className="flex justify-center">
      <div className="w-full md:w-2/3">
        <div className="rounded-base bg-light p-8 shadow-[0_4px_12px_rgba(0,0,0,0.06)]">
          <h3 className="mb-8">{texts.confirmation.title}</h3>
          <p className="mb-1 font-semibold">{texts.confirmation.audienceLabel}</p>
          <div className="mb-6 rounded-base bg-background2 px-5 py-4">
            <div className="flex flex-wrap gap-2">
              <span className="inline-flex items-center rounded-full bg-background px-3 py-1.5 text-[0.85rem]">
                {mapAudience()}
              </span>
              {state.excludeRecipientUserIds.length > 0 && (
                <span className="inline-flex items-center rounded-full bg-background px-3 py-1.5 text-[0.85rem]">
                  {texts.confirmation.excludedCountLabel.replace(
                    '{n}',
                    String(state.excludeRecipientUserIds.length),
                  )}
                </span>
              )}
            </div>
          </div>

          <p className="mb-1 font-semibold">{texts.confirmation.titleLabel}</p>
          <div className="mb-6 rounded-base bg-background2 px-5 py-4">
            <p className="m-0">{state.title || texts.confirmation.noTitle}</p>
          </div>

          <p className="mb-1 font-semibold">{texts.confirmation.messageLabel}</p>
          <div className="mb-6 rounded-base bg-background2 px-5 py-4">
            <p className="m-0 whitespace-pre-wrap">
              {state.message || texts.confirmation.noMessage}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

